import { IconProps } from './interfaces';

export const IconTooltip = ({ className }: IconProps) => {
    return (
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className={className}>
            <g fillRule="evenodd" transform="translate(4 4)">
                <circle cx="8" cy="8" r="7.5" fill="currentColor" fillRule="nonzero" stroke="var(--base-contrast-subtle)"></circle>
                <path
                    fill="none"
                    d="M8 10V8.602c0-.366.405-.688.54-.772.793-.492 1.46-.974 1.46-1.872C10 4.877 9.105 4 8 4s-2 .877-2 1.958"
                ></path>
                <circle cx="8.1" cy="11.75" r="0.5" fill="inherit" stroke="none"></circle>
            </g>
        </svg>
    );
};
